import { render, staticRenderFns } from "./OAuthIntegrationCard.vue?vue&type=template&id=5caa763e&scoped=true&"
import script from "./OAuthIntegrationCard.vue?vue&type=script&lang=js&"
export * from "./OAuthIntegrationCard.vue?vue&type=script&lang=js&"
import style0 from "./OAuthIntegrationCard.vue?vue&type=style&index=0&id=5caa763e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa763e",
  null
  
)

export default component.exports